import { Controller } from '@hotwired/stimulus'
import { render } from 'nunjucks'
import sidePanel from 'side-panel-menu-thing'

import { Events, Menus } from '../constants'

import {
    target,
    targets,
    addClass,
    removeClass,
    toggleClass,
    retrieveSession,
    subscribeEvent,
    unsubscribeEvent,
    checkPermission,
    sendEvent,
    setHtml
} from '../utils'

import { matchWithUrl, router, Routes } from '../router'

export default class extends Controller {

    static targets = [
        'drawer',
        'settings',
        'menus',
        'menu',
        'button-drawer-mobile',
        'button-back-mobile',
        'button-drawer',
        'button-back',
    ]

    static values = {
        selected: String
    }

    selectedValue = null

    drawer = () => target(this, 'drawer')

    menus = () => target(this, 'menus')

    settings = () => target(this, 'settings')

    menu = () => targets(this, 'menu')

    buttonDrawerMobile = () => target(this, 'button-drawer-mobile')

    buttonBackMobile = () => target(this, 'button-back-mobile')

    buttonDrawer = () => target(this, 'button-drawer')

    buttonBack = () => target(this, 'button-back')

    sidePanel = null

    isSidePanelOpened = false

    initialize = () => {

        const main = document.getElementById('main')

        this.selectedValue = null

        this.render()

        this.select({ detail: { hashString: location.hash } })

        this.sidePanel = sidePanel({
            target: main,
            content: this.drawer(),
            width: 320,
            duration: 450,
            fixed: false,
            left: true,
            dragOpen: true,
            preventScroll: true,
            onShow: this.onOpenDrawer,
            onHide: this.onCloseDrawer
        })
    }

    connect = () => {

        subscribeEvent(Events.ON_LOGIN, this.render)
        subscribeEvent(Events.ON_NAVIGATE, this.select)
    }

    disconnect = () => {

        unsubscribeEvent(Events.ON_LOGIN, this.render)
        unsubscribeEvent(Events.ON_NAVIGATE, this.select)
    }

    render = () => {

        retrieveSession().then((session) => {

            if (! session) {

                sendEvent(Events.SHOW_LOGIN, { message: '' })

                return
            }

            const drawer = checkPermission(session, Menus.drawer)

            drawer.name = session.rpe

            setHtml(this.drawer(), render('drawer.html', drawer))

            setHtml(this.menus(), render('menu.html', checkPermission(session, Menus.menu)))

            setHtml(this.settings(), render('settings.html', checkPermission(session, Menus.settings)))

            router.updatePageLinks()

        }).catch(() => {

            sendEvent(Events.SHOW_LOGIN, { message: '' })
        })
    }

    element = (href) => {

        return this.elementInSettings(href) || this.elementInDrawer(href)
    }

    elementInSettings = (href) => {

        const selector = `a[href^='${href}']`

        return this.menus().querySelector(selector)
    }

    elementInDrawer = (href) => {

        const selector = `a[href^='${href}']`

        return this.drawer().querySelector(selector)
    }

    onOpenDrawer = () => {

        this.isSidePanelOpened = true
    }

    onCloseDrawer = () => {

        this.isSidePanelOpened = false
    }

    toggleDrawer = () => {

        if (this.sidePanel) {

            if (this.isSidePanelOpened) {

                this.sidePanel.hide()

            } else {

                this.sidePanel.show()
            }
        }
    }

    hideDrawer = () => {

        if (this.sidePanel) {

            this.sidePanel.hide()
        }
    }

    hideMenus = () => {

        removeClass(this.menus(), 'is-active')
    }

    toggleMenus = (event) => {

        toggleClass(this.menus(), 'is-active')

        event.stopPropagation()
    }

    select = ({ detail: { hashString } }) => {

        if (hashString) {

            if (hashString.endsWith(Routes[1].url) || hashString === '/') {

                addClass(this.buttonBackMobile(), 'is-hidden')
                addClass(this.buttonBack(), 'is-hidden')

                removeClass(this.buttonDrawerMobile(), 'is-hidden')
                removeClass(this.buttonDrawer(), 'is-hidden')

            } else {

                addClass(this.buttonDrawerMobile(), 'is-hidden')
                addClass(this.buttonDrawer(), 'is-hidden')

                removeClass(this.buttonBackMobile(), 'is-hidden')
                removeClass(this.buttonBack(), 'is-hidden')
            }
        }

        const selected = this.menu().find((element) =>
            element.getAttribute('href').endsWith(hashString))

        if (this.selectedValue) {

            const previousSelected = this.element(this.selectedValue)

            removeClass(previousSelected, 'is-active')
        }

        if (selected) {

            addClass(selected, 'is-active')

            this.selectedValue = selected.getAttribute('href')
        }

        this.hideDrawer()
    }

    back = () => {

        let url = Routes[1].url

        if (matchWithUrl(Routes[6].url)) {

            url = Routes[5].url
        }

        router.navigate(url, {
            historyAPIMethod: 'replaceState'
        })
    }
}
